import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { FiPlus } from "react-icons/fi";
import { useScopeId } from "@core/hooks/useRouteParamId";
import CreateSubGroupModal from "@features/report/subgroup/components/CreateSubGroupModal";
import ReportSubGroupTable from "@features/report/subgroup/components/ReportSubGroupTable";
import RequirePermission from '@core/components/RequirePermission';
import { ACTION_CODES } from '@features/entity/types/actionCodes';

const ManageReportSubGroups: React.FC = () => {
    const nationId = useScopeId() ?? 0;
    const [showCreate, setShowCreate] = useState(false);
    const [tableKey, setTableKey] = useState(0);

    return (
        <Container fluid className="py-4" data-testid="admin-sub-groups-page-container">
            <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-3 mb-4">
                <div className="ntcog-page-title-block mb-0">
                    <h1 className="ntcog-page-heading mb-1">Report Sub Groups</h1>
                    <p className="text-muted mb-0">
                        Create and manage reusable sub groups for report templates.
                    </p>
                </div>

                {Number.isFinite(nationId) && nationId > 0 && (
                    <RequirePermission mode="section" action={ACTION_CODES.CREATE_REPORT_SUB_GROUP} scopeType="NATION" scopeId={nationId}>
                        <Button
                            variant="primary"
                            onClick={() => setShowCreate(true)}
                            aria-label="Create a new report sub group"
                            data-testid="new-sub-group-button"
                        >
                            <FiPlus className="me-2" />
                            New Sub Group
                        </Button>
                    </RequirePermission>
                )}
            </div>

            <ReportSubGroupTable
                nationId={nationId}
                showPagination={true}
                refreshToken={tableKey}
            />

            <CreateSubGroupModal
                show={showCreate}
                onHide={() => setShowCreate(false)}
                nationId={nationId}
                onCreated={() => {
                    setShowCreate(false);
                    setTableKey((prev) => prev + 1);
                }}
            />
        </Container>
    );
};

export default ManageReportSubGroups;
